import { PostAttachment } from '../types/post-types';

/** Attachment fields stored in the database / sent in DTOs (no hydrated asset). */
export type PostAttachmentInput = Pick<
  PostAttachment,
  'id' | 'assetId' | 'description' | 'displayName' | 'order'
>;

/** Strip the hydrated `asset` field from attachments for storage / transport. */
export function stripAttachmentAssets(
  attachments?: PostAttachment[] | null,
): PostAttachmentInput[] {
  if (!attachments) return [];
  return attachments.map((a) => ({
    id: a.id,
    assetId: a.assetId,
    description: a.description,
    displayName: a.displayName,
    order: a.order,
  }));
}
